export const SERVER_TABLE_TAG = 'SERVER';
